export { PrepareThirdContainer as default } from "containers/FuneralPrepareContainer";
